import React from "react";
import { Grid, TextField } from "@material-ui/core";
import Services from "../../services/Services";
import IServiceCallNote from "../../models/IServiceCallNote";
import styled from "styled-components";
import { getErrorsGrid, processErrors } from "../../functions/errorHandling";
import { connect } from "react-redux";
import { selectStatusDispatch } from "../../store/status/selectors";
import { IPendingItem } from "../../store/status/types";
import { NegativeFormButton, SecondaryFormButton } from "./FormButton";

const PendingAddNote: IPendingItem = {
  id: "b8a87383-dd4c-4731-a435-d71532e8cb4a",
  description: "Adding note...",
};

interface ISCNGridProps {
  addPending: (item: IPendingItem) => void;
  completePending: (item: IPendingItem) => void;
  token: string;
  serviceCallNumber: string;
  updateNotes: Function;
  handleShowNewNoteFields: () => void;
}

const StyledTextField = styled(TextField)`
  width: 600px;
`;

const ServiceCallNoteGrid = (props: ISCNGridProps) => {
  const { addPending, completePending, handleShowNewNoteFields } = props;
  const [noteSummary, setNoteSummary] = React.useState("");
  const [noteDetail, setNoteDetail] = React.useState("");
  const [noteErrors, setNoteErrors] = React.useState<string[]>([]);

  const handleSummaryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNoteSummary(event.target.value);
  };

  const handleDetailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNoteDetail(event.target.value);
  };

  async function handleSubmitNote(
    token: string,
    noteSummary: string,
    noteDetail: string,
    ticketNumber: string,
    updateNotes: Function,
    showAddNoteGrid: () => void,
  ) {
    try {
      addPending(PendingAddNote);
      let svcs = new Services();
      let scRepo = await svcs.ServiceCallNoteRepository();
      let note: IServiceCallNote = {
        summary: noteSummary,
        detail: noteDetail,
        serviceCallNumber: ticketNumber,
        noteID: 0,
        dateSubmitted: new Date().toUTCString(),
        type: "Response",
      };

      await scRepo.AddServiceCallNote(token, note);
      updateNotes();
      showAddNoteGrid();
      setNoteDetail("");
      setNoteSummary("");
    } catch (error) {
      setNoteErrors(processErrors(error));
    }
    completePending(PendingAddNote);
  }

  return (
    <>
      {getErrorsGrid(noteErrors)}
      <Grid item>
        <StyledTextField id="newNoteSummary" label="Title" variant="outlined" onChange={handleSummaryChange} />
      </Grid>
      <Grid item>
        <StyledTextField
          id="newNoteDescription"
          label="Add your note here..."
          variant="outlined"
          multiline={true}
          rows={4}
          rowsMax={100}
          onChange={handleDetailChange}
        />
      </Grid>
      <Grid item container direction="row" spacing={2}>
        <Grid item>
          <NegativeFormButton onClick={() => handleShowNewNoteFields()}>Cancel</NegativeFormButton>
        </Grid>
        <Grid item>
          <SecondaryFormButton
            onClick={() => handleSubmitNote(props.token, noteSummary, noteDetail, props.serviceCallNumber, props.updateNotes, props.handleShowNewNoteFields)}
            variant="contained"
          >
            Save Note
          </SecondaryFormButton>
        </Grid>
      </Grid>
    </>
  );
};

export default connect(null, dispatch => ({
  ...selectStatusDispatch(dispatch),
}))(ServiceCallNoteGrid);
